import { createContext, useContext } from 'react';

/**
 * A PageUI section that can be saved to a user's lists.
 * Matches the item types/details that `useReduxListItems` uses.
 */
export type PageUISaveableItem = {
  type: 'trail' | 'map' | 'track';
  id: number;
  isCustomRoute?: boolean;
};

export type PageUISave = {
  /** Whether the item is in one of the user's lists. */
  isSaved: (item: PageUISaveableItem) => boolean;
  isCompleted: (item: PageUISaveableItem) => boolean;
  isVerified: (item: PageUISaveableItem) => boolean;
  /** Saves the item to a list, or opens the host's list or sign-up modal. */
  onSaveClick: (item: PageUISaveableItem) => void;
};

/**
 * Lets the hosting app save items to the user's lists. The host app owns the list & sign-up modals.
 * Without a provider, sections have no save button.
 */
export const PageUISaveContext = createContext<PageUISave | undefined>(undefined);

export const usePageUISave = () => useContext(PageUISaveContext);
